"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketLocationInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketLocationInput.js.map